<ion-header>
    <ion-toolbar>
        <ion-title> {{ 'Add collection' | translate }}</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="close()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list *ngIf="form" class="content-width">
        <form [formGroup]="form">
            <ion-row>
                <ion-col>
                    <ion-item>
                        <ion-input label="{{ 'Count' | translate }}" label-placement="floating" type="number" formControlName="matchUpCount"></ion-input>
                    </ion-item>
                </ion-col>
                <ion-col size="8">
                    <ion-item>
                        <ion-select label="{{ 'Match format' | translate }}" label-placement="stacked" interface="popover" formControlName="matchUpType">
                            <ion-select-option value="SINGLES">{{'Singles' | translate}}</ion-select-option>
                            <ion-select-option value="DOUBLES">{{'Doubles' | translate}}</ion-select-option>
                        </ion-select>
                    </ion-item>
                </ion-col>
            </ion-row>
            <ion-item>
                <ion-input label="{{ 'Match collection name' | translate }}" label-placement="floating" type="text" formControlName="collectionName"></ion-input>
            </ion-item>

            <ion-item>
                <ion-toggle #exhibition justify="space-between" formControlName="exhibition"> {{ 'Exhibition' | translate }}</ion-toggle>
            </ion-item>

            <ion-item *ngIf="!exhibition.checked">
                <ion-select label="{{ 'Scoring' | translate }}" label-placement="stacked" interface="popover"  [value]="tie.tieFormat?.winCriteria?.aggregateValue ? 'gameValue' : 'matchUpValue'" #scoring (ionChange)="scoringChanged($event)">
                    <ion-select-option value="matchUpValue"> {{ '1 point for each match won' | translate }}</ion-select-option>
                    <ion-select-option value="collectionValue"> {{ '1 point for more matches won' | translate }}</ion-select-option>
                    <ion-select-option value="gameValue"> {{ '1 point for each game won' | translate }}</ion-select-option>
                    <ion-select-option value="pointValue"> {{ '1 point for each point won' | translate }}</ion-select-option>
                </ion-select>
            </ion-item>

            <ion-item *ngIf="scoring?.value === 'collectionValue'">
                <ion-input label="{{ 'Collection value' | translate }}" label-placement="floating" class="ion-text-right" type="number" formControlName="collectionValue" pattern="[0-9]"></ion-input>
            </ion-item>

            <app-match-format-form *ngIf="tie.discipline !== 'PICKLEBALL' && tie.discipline !== 'BADMINTON' && tie.discipline !== 'TABLE_TENNIS' && tie.discipline !== 'SQUASH'"  matchFormat="SET3-S:6/TB7@6" (updatedMatchFormat)="updateCollectionMatchFormat($event)"></app-match-format-form>
            <app-pickleball-match-format-form *ngIf="tie.discipline === 'PICKLEBALL'" matchFormat="SET3-S:1/WB2-G:11/S" (updatedMatchFormat)="updateCollectionMatchFormat($event)"></app-pickleball-match-format-form>
            <app-badminton-match-format-form  *ngIf="tie.discipline === 'BADMINTON'" [matchFormat]="'SET3-S:1/WB2:30-G:21/R'" (updatedMatchFormat)="updateCollectionMatchFormat($event)"></app-badminton-match-format-form>
            <app-table-tennis-match-format-form *ngIf="tie.discipline === 'TABLE_TENNIS'" [matchFormat]="getMatchFormat()" [dividerTitle]="'Score format'" (updatedMatchFormat)="updateCollectionMatchFormat($event)"></app-table-tennis-match-format-form>
            <app-squash-match-format-form *ngIf="tie.discipline === 'SQUASH'" [matchFormat]="'SET5-S:1/G:11/OT'" (updatedMatchFormat)="updateCollectionMatchFormat($event)"></app-squash-match-format-form>
        </form>
    </ion-list>
</ion-content>
<ion-footer>
    <ion-toolbar>
        <ion-button [disabled]="isSubmitting" class="ion-margin" (click)="createCollection()" expand="block">
            <span *ngIf="!isSubmitting">{{ 'Create' | translate }}</span>
            <ion-spinner name="crescent" *ngIf="isSubmitting"></ion-spinner>
        </ion-button>
    </ion-toolbar>
</ion-footer>